export default function Featured() {
    return (
        <div className="flex flex-col items-center">
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                <a
                    href="https://www.producthunt.com/posts/copybuddy-io?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-copybuddy-io"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=454288&theme=neutral"
                        alt="CopyBuddy.io - Send cold emails your prospects love responding to | Product Hunt"
                        className="w-[250px] h-[62px]"
                    />
                </a>
                <a 
                    href="https://www.toolify.ai/tool/copybuddy-io/?ref=embed" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="cursor-pointer"
                >
                    <img 
                        src="https://cdn.toolify.ai/featured_neutral.svg" 
                        className="w-[250px] h-[60px]" 
                        alt="CopyBuddy.io : Reviews, Pricing, Core features, Use cases, alternatives" 
                    />
                </a>
            </div>
        </div>
    )
}